import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h1 className="hero-title">Wholesale Wins Start Here</h1>
          <p className="hero-subtitle">
            KVP Trade LTD: London’s toughest cash & carry. Bulk buys, brutal prices, built for traders.
          </p>
          <div className="hero-cta-group">
            <motion.a
              href="#shop"
              className="hero-cta primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              Shop Deals Now
            </motion.a>
            <motion.a
              href="#register"
              className="hero-cta secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              Join Free
            </motion.a>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <img
            src="https://dmrqkbkq8el9i.cloudfront.net/Pictures/2000xAny/4/5/4/132454_20180610_223705_resized-web.jpg"
            alt="Bulk Goods Stack"
            className="hero-image"
          />
          <div className="deal-stamp">Up to 60% Off</div>
        </motion.div>
      </div>

      <div className="hero-ticker">
        <span className="ticker-text">
          💥 Flash Sale: 3-for-2 on Drinks | £200 Off Pallet Orders | Open 7 Days - No Membership Fees 💥
        </span>
      </div>
    </section>
  );
};

export default HeroSection;